import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { ExternalLink } from 'types';

export const getExternalLinks = async (): Promise<ExternalLink[]> => {
  const { data } = await axios.get(`/api/external-links/`);
  return data as ExternalLink[];
};

type QueryFnType = typeof getExternalLinks;

type UseExternalLinksOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useExternalLinks = ({ config }: UseExternalLinksOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['externalLinks'],
    queryFn: () => getExternalLinks(),
    ...config,
  });
};
